import React, { Component } from "react";
import { Icon, Button, Grid } from "semantic-ui-react";

class SocialMedia extends Component {
  render() {
    return (
      <div>
        <Grid columns='equal' padded centered>
          <Grid.Row>
            {this.props.socialMedia.linkedin &&
              <Grid.Column>
                <Button icon color='linkedin' href={this.props.socialMedia.linkedin}>
                  <Icon name='linkedin' />	
                </Button>
              </Grid.Column>}
            {this.props.socialMedia.hal &&
              <Grid.Column>
                <Button icon color='google plus' href={this.props.socialMedia.hal}>
                  <Icon name='graduation cap' />	
                </Button>
              </Grid.Column>}
            {this.props.socialMedia.twitter && 
              <Grid.Column>
                <Button icon color='twitter' href={this.props.socialMedia.twitter}>
                  <Icon name='twitter' />
                </Button>
              </Grid.Column>}
            {this.props.socialMedia.youtube && 
              <Grid.Column>
                <Button icon color='youtube' href={this.props.socialMedia.youtube}>
                  <Icon name='youtube' />
                </Button>
              </Grid.Column>}
            {this.props.socialMedia.url && 
              <Grid.Column>
                <Button icon color='blue' href={this.props.socialMedia.url}>
                  <Icon name='globe' />
                </Button>
              </Grid.Column>}
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default SocialMedia;




// WEBPACK FOOTER //
// ./src/scenes/ProfilPage/components/socialMedia.js